import { Box, Flex, Grid, Text, css, useTheme } from "@chakra-ui/react"
import colors from "@constants/colors"
import Image from "next/image"
import Link from "@components/Link"
import Tag from "@components/universal/Tag"
import { getProductUrl } from "@utils/urls"
import React from "react"

const MobileProductList: React.FC<any> = ({ containerRef, product }) => {
  const { slug, tag, image, name, model, category, variants, price } = product

  const theme = useTheme()
  const styles = css({
    borderTop: "1px solid #E9E9E9",
    padding: "1.5rem 1rem",
    header: {
      fontSize: "16px",
      fontWeight: "800",
    },
    p: {
      fontSize: "13.5px",
      fontWeight: "800",
    },
    span: {
      fontSize: "13.5px",
      fontWeight: "500",
      color: colors.midAccessible,
    },
  })(theme)

  return (
    <Grid
      ref={containerRef}
      position="relative"
      gridTemplateColumns="1fr 3fr"
      padding="1rem"
      css={styles}
    >
      <Box position="relative" gridTemplateColumns="1">
        <Link href={getProductUrl(slug)} useAnchor>
          {image && (
            <Image
              src={image}
              alt={"Product Image"}
              layout="fill"
              objectFit="contain"
              objectPosition="center"
            />
          )}
        </Link>
      </Box>
      <Box display="flex" flexDir="column">
        <Link href={getProductUrl(slug)} useAnchor>
          <Text as="header">{name}</Text>
        </Link>
        <Text>{model}</Text>
        <Flex flexDir="column" py=".25rem">
          <Text as="span">{category}</Text>
          <Text as="span">{variants}</Text>
        </Flex>
        <Text>{price}</Text>
        <Box py=".25rem">{tag && <Tag bg={colors.brand}>{`${tag}!`}</Tag>}</Box>
      </Box>
    </Grid>
  )
}

export default MobileProductList
